import * as React from "react";

import { SignedOutChatPage } from "@/features/home/SignedOutChatPage";

import { GuestChatPage } from "./GuestChatPage";
import { hasGuestSession } from "./guestApi";

/**
 * Which of the two public chat pages an outsider gets, decided without asking the server.
 *
 * <p>The choice has to be made before anything runs, and the honest signal is a cookie the browser
 * can read (D-77). Calling the session endpoint to find out would mean a cold load of `/chat` made
 * a request, and pre-verification this route is the bundle and nothing else (D-37) — a promise that
 * is worth keeping precisely because it is the kind that erodes silently.</p>
 *
 * <p>The presence cookie can be stale: it and the session expire together, but a browser that was
 * asleep may hold one whose session the sweeper has already collected. That is why
 * {@link GuestChatPage} falls back here rather than showing an error. Being briefly wrong in this
 * direction costs a visitor a flicker; being wrong the other way would mean showing a signed-in
 * person a page telling them to sign in.</p>
 */
export function PublicChatRoute(): React.ReactElement {
  const [guest, setGuest] = React.useState(() => hasGuestSession());

  if (!guest) return <SignedOutChatPage />;
  return <GuestChatPage onSignedOut={() => setGuest(false)} />;
}
